import POSPage from './pages/admin/POSPage';
import {ScannerProvider} from './components/inventory/scanner/ScannerProvider';
import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import { ThemeProvider } from "./context/ThemeContext";

// Pages
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import FavoritesPage from "./pages/FavoritesPage";
import ProfilePage from "./pages/ProfilePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AdminPage from "./pages/admin/AdminPage";
import SupportButton from '@/components/SupportButton';

import CookieConsent from "./components/CookieConsent";
import LegalPage from "./pages/LegalPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <CartProvider>
            <FavoritesProvider>
              <BrowserRouter><ScannerProvider>
                <CookieConsent />
                <SupportButton />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/art/:article" element={<ProductPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/order-success" element={<OrderSuccessPage />} />
                  <Route path="/favorites" element={<FavoritesPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/privacy_policy" element={<PrivacyPolicyPage />} />
                  <Route path="/cookie-consent" element={<LegalPage kind="cookies" />} />
                  <Route path="/data-consent" element={<LegalPage kind="data" />} />
                  <Route path="/purchase-info" element={<LegalPage kind="purchase" />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/admin/pos" element={<POSPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                </Routes>
              </ScannerProvider></BrowserRouter>
            </FavoritesProvider>
          </CartProvider>
        </AuthProvider>
      </ThemeProvider>

    </div>
  );
}

export default App;
